import { Box } from '@mui/system';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { unSelect } from '../features/WTG/TurbineSlice';



const Index = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(unSelect())
        navigate("/parkview", { replace: true });
    }, []);

    return (
        <Box>
          
        </Box>
    );
};
export default Index;
